import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import apiClient from '../lib/api'
import {
  getToken, setToken, clearToken,
  getAdmin, setAdmin, clearAdmin
} from '../lib/auth'

export const ROLE_LABEL = {
  ROOT: 'Root',
  ADMIN: 'Admin',
  CHECKIN: 'Voluntário'
}

export function roleLabel(role) {
  return ROLE_LABEL[role] || role || ''
}

export const useAuthStore = defineStore('auth', () => {
  const token = ref(getToken())
  const admin = ref(getAdmin())

  const isAuthenticated = computed(() => !!token.value)
  const adminName = computed(() => admin.value?.name || '')
  const role = computed(() => admin.value?.role || null)
  const isRoot = computed(() => role.value === 'ROOT')
  const isAdmin = computed(() => role.value === 'ADMIN')
  const isCheckin = computed(() => role.value === 'CHECKIN')
  const canSeeFinanceiro = computed(() => role.value !== 'CHECKIN')
  const canManageAcampantes = computed(() => role.value === 'ROOT' || role.value === 'ADMIN')
  const canManageAdmins = computed(() => role.value === 'ROOT' || role.value === 'ADMIN')

  async function login(email, password) {
    const res = await apiClient.post('/auth/login', { email, password })
    token.value = res.data.token
    admin.value = res.data.admin
    setToken(res.data.token)
    setAdmin(res.data.admin)
    return res.data
  }

  function logout() {
    token.value = null
    admin.value = null
    clearToken()
    clearAdmin()
  }

  async function restore() {
    if (!token.value) return
    try {
      const res = await apiClient.get('/auth/me')
      admin.value = res.data.admin
      setAdmin(res.data.admin)
    } catch {
      logout()
    }
  }

  return {
    token, admin,
    isAuthenticated, adminName,
    role, isRoot, isAdmin, isCheckin,
    canSeeFinanceiro, canManageAcampantes, canManageAdmins,
    login, logout, restore
  }
})
